var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 29.6867C30.0622 29.6867 28.6267 30.3193 27.5289 31.3102L12.4767 22.5602C12.5822 22.0753 12.6667 21.5904 12.6667 21.0843C12.6667 20.5783 12.5822 20.0934 12.4767 19.6084L27.36 10.9428C28.5 11.997 29.9989 12.6506 31.6667 12.6506C35.1711 12.6506 38 9.8253 38 6.3253C38 2.8253 35.1711 0 31.6667 0C28.1622 0 25.3333 2.8253 25.3333 6.3253C25.3333 6.83133 25.4178 7.31626 25.5233 7.8012L10.64 16.4669C9.5 15.4127 8.00111 14.759 6.33333 14.759C2.82889 14.759 0 17.5843 0 21.0843C0 24.5843 2.82889 27.4096 6.33333 27.4096C8.00111 27.4096 9.5 26.756 10.64 25.7018L25.6711 34.4729C25.5656 34.9157 25.5022 35.3795 25.5022 35.8434C25.5022 39.2379 28.2678 42 31.6667 42C35.0656 42 37.8311 39.2379 37.8311 35.8434C37.8311 32.4488 35.0656 29.6867 31.6667 29.6867Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.de4381de4dc50d39c9e29422248987e6.svg";
export { ForwardRef as ReactComponent };